import { StatusBar } from "expo-status-bar"
import "@/styles/global.css"
import { GluestackUIProvider } from "@/components/gluestack/gluestack-ui-provider"
import { SafeAreaProvider } from "react-native-safe-area-context"
import { AuthProvider } from "./auth"
import { AppNavigator } from "./navigation"
import { ApiProvider } from "./providers/ApiProvider"
import { DataProvider, useData } from "./providers/DataProvider"
import { SocketProvider } from "./providers/SocketProvider"
import "./styles"
import { AnalyticsProvider } from "./providers/AnalyticsProvider"

const InnerApp = () => {
  const { userSettings } = useData()

  return (
    <GluestackUIProvider mode={userSettings.theme!}>
      <SafeAreaProvider style={{ flex: 1 }}>
        <StatusBar style="auto" />
        <AppNavigator />
      </SafeAreaProvider>
    </GluestackUIProvider>
  )
}

export default function App() {
  return (
    <ApiProvider>
      <AnalyticsProvider>
        <AuthProvider>
          <SocketProvider>
            <DataProvider>
              <InnerApp />
            </DataProvider>
          </SocketProvider>
        </AuthProvider>
      </AnalyticsProvider>
    </ApiProvider>
  )
}
